module.exports = __webpack_public_path__ + "img/gszh.24858249.jpg";